module.exports = __webpack_public_path__ + "/images/logo-af-coopel.5ed7220.svg";